import { IconProps } from "./types";
import React from "react";

export const StopIcon = ({
  className,
  fill = "currentColor",
  style = {},
  stop = 0,
  textColor = "#000",
}: IconProps & {
  stop: number;
  textColor?: string;
}): React.ReactElement => (
  <svg
    height="32"
    width="32"
    viewBox="0 0 32 32"
    className={className}
    style={style}
  >
    <circle id="svgCircle" fill={fill} cx="16" cy="16" r="10" />
    <text
      id="svgText"
      name="stopNumber"
      x="16"
      y="20"
      style={{
        fontSize: "10pt",
        fontFamily: "arial",
        fontWeight: "bold",
        textAnchor: "middle",
        fill: textColor,
      }}
    >
      {stop}
    </text>
  </svg>
);
